import Vue from "vue";
import Vuex from "vuex";
import constantes from "../constants";
import Operacion from "@/modules/operacion/operacion.module.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    drawer: false,
    theme: false,
    domain: {
      domainName: constantes.domainName,
      domainNameWithHttp: constantes.domainNameWithHttp,
      domainNameForApi: constantes.domainNameForApi,
      domainAusa: constantes.domainAusa,
      domainNameDev: constantes.domainNameDev,
    },
    user: new Map(),
    informationPage: {
      expireSession: false,
      nameCookiePGV2: constantes.nameCookiePGV2, //"PruebonPGV2",
      nameLocalStoragePGV2: constantes.nameLocalStoragePGV2,
      nameLocalStorageFinanzas: constantes.nameLocalStorageFinanzas,
    },
    permission: {
      global: 294,
      single: {
        tablero: 289,
        gerente: 347,
        expjuridicos: 28
      },
    },
    messagesList: [],
    listaTerminada: [],
    ivrPermiso: false,
    ivr: 0,
    checklistmensajes: [],
    asegurado: 0,

    reCaptchaSiteKey: "6LfNd74ZAAAAACjKaSPsXu7-_Gq6Sb2rTvpIoIZJ",
    reCaptchaSecretKey: "6LfNd74ZAAAAAPd7cGUTFYVM8eCzm8LvBoJ3xfre",
    reCaptchaVersion: "v2",

    reporteMenuOption: "",
    privateKey: "ThiIsJustTheKeyWeAreUsingAndItCanActuallyBeWhatEver2704",

    maxLengthComentarios: 400,
  },
  mutations: {
    fillDataUser(state, data) {
      state.user.set(state.permission.global, { uslogin: data });
    },
    changeExpireSession(state, data) {
      state.informationPage.expireSession = data;
    },
    toggleDrawer(state) {
      state.drawer = !state.drawer;
    },
    toggleTheme(state, data) {
      state.theme = data;
    },
    //WhatsApp
    fillListaMensajes(state, data) {
      //console.log("EN EL FILL ANTES ", state.messagesList);

      //console.log("Entra al fillListaMensajes", data);
      state.messagesList = data;

      //console.log("EN EL FILL DESPUES ", state.messagesList);
    },
    addMessageToMessageList(state, data) {
      //console.log("La lista antes de ", state.messagesList);
      //console.log("Entra al add message", data);
      state.messagesList.push(data);

      //console.log("La lista despues de ", state.messagesList);
    },
    emptyMessageList(state) {
      state.messagesList = null;
    },
    fillListaTerminada(state, data) {
      state.listaTerminada = data;
    },
    changePropListaTerminada(state, data) {
      state.listaTerminada = data;
    },
    changeivrPermiso(state, data) {
      state.ivrPermiso = data;
    },
    changeivrNum(state, data) {
      state.ivr = data;
    },
    changeAsegurado(state, data) {
      state.asegurado = data;
    },
    changePropMessageList(state, { auxData, index }) {
      //console.log("Entre al change prop con", auxData, index);
      Vue.set(state.messagesList, index, auxData);
    },
    //changePropMessageList(state,data, index) {
    //    console.log('Entre al change prop con' , data, index);
    //    Vue.set(state.messagesList, index, data);
    //},
    replaceListaMensajes(state, data) {
      //console.log("El data que llego A replaceListaMensajes es ", data);

      //console.log("La lista replaceListaMensajes ANTES ", state.messagesList);

      //state.messagesList = data;
      setTimeout(function () {
        state.messagesList = data;
      }, 500);

      //console.log("La lista replaceListaMensajes de ", state.messagesList);
    },
    //Clasificar Mensajes
    seleccionarMensaje(state, data) {
      state.checklistmensajes.push(data);
    },
    quitarMensaje(state, val) {
      var index = state.checklistmensajes.indexOf(val);
      if (index > -1) {
        state.checklistmensajes.splice(index, 1);
      }
    },
    limpiarlistacheck(state) {
      state.checklistmensajes = [];
    },
    changeReporteMenuOption(state, data) {
      state.reporteMenuOption = data;
    },
  },
  actions: {
    setChangeExpireSession({ commit }, data) {
      commit("changeExpireSession", data);
    },
    TOGGLE_DRAWER({ commit }) {
      commit("toggleDrawer");
    },
    TOGGLE_THEME({ commit }, data) {
      commit("toggleTheme", data);
    },
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    DRAWER_STATE(state) {
      return state.drawer;
    },
    THEME_STATE(state) {
      return state.theme;
    },
    getMessagesList(state) {
      return state.messagesList;
    },
    getChecklistmensajes(state) {
      return state.checklistmensajes;
    },
  },
  modules: {
    Operacion,
  },
});
